export default "__VITE_ASSET__0ecd8342__"